import script from "./PasswordDesc.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordDesc.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordDesc.vue?vue&type=style&index=0&id=ccd3ffbc&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ccd3ffbc"]])

export default __exports__